var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPhone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Phone"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "phone"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M16.95 21.1668C13.2075 21.162 9.61968 19.6731 6.97335 17.0268C4.32701 14.3804 2.83816 10.7926 2.83331 7.05015C2.83331 5.93182 3.27757 4.85929 4.06835 4.06851C4.85912 3.27773 5.93165 2.83348 7.04998 2.83348C7.28679 2.83167 7.52321 2.85317 7.75581 2.89765C7.98068 2.93092 8.20174 2.98619 8.41581 3.06265C8.56637 3.11547 8.70054 3.20668 8.80504 3.32726C8.90954 3.44784 8.98076 3.5936 9.01165 3.75015L10.2675 9.25015C10.3013 9.39944 10.2973 9.55483 10.2556 9.70214C10.214 9.84945 10.1361 9.98399 10.0291 10.0935C9.90998 10.2218 9.90081 10.231 8.77331 10.8176C9.67622 12.7984 11.2604 14.3891 13.2375 15.3001C13.8333 14.1635 13.8425 14.1543 13.9708 14.0351C14.0803 13.9282 14.2148 13.8503 14.3622 13.8087C14.5095 13.767 14.6649 13.763 14.8141 13.7968L20.3141 15.0526C20.4657 15.0878 20.6058 15.1609 20.7212 15.2652C20.8367 15.3694 20.9237 15.5013 20.9741 15.6485C21.0515 15.8661 21.1098 16.09 21.1483 16.3176C21.1852 16.548 21.2036 16.781 21.2033 17.0143C21.1864 18.1279 20.7297 19.1895 19.9328 19.9675C19.1359 20.7455 18.0636 21.1766 16.95 21.1668Z",
    fill: "#971EFF"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhone);
export default __webpack_public_path__ + "static/media/Phone.d0e9dd49c41d80391e2344b6e6915847.svg";
export { ForwardRef as ReactComponent };